import apiClient from './client';

export type ReportStatus = 'pending' | 'complete' | 'failed';

export interface ChecksByType {
  [type: string]: { total: number; passed: number };
}

export interface StoreReport {
  id: number;
  audit_run_id: number | null;
  title: string;
  overall_score: number;
  total_checks: number;
  passed_checks: number;
  failed_checks: number;
  pass_rate: number;
  checks_by_type: ChecksByType;
  recommendation_counts: Record<string, number>;
  ai_summary: string;
  ai_model: string | null;
  prompt_tokens: number | null;
  completion_tokens: number | null;
  cost_usd: number;
  status: ReportStatus;
  status_label: string;
  is_ready: boolean;
  created_at: string | null;
  updated_at: string | null;
}

export interface PaginatedReports {
  success: boolean;
  data: StoreReport[];
  meta: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

export const reportsApi = {
  list(page = 1, perPage = 15): Promise<PaginatedReports> {
    return apiClient.get('/reports', { params: { page, per_page: perPage } }).then((r) => r.data);
  },

  generate(auditRunId?: number): Promise<{ success: boolean; data: StoreReport }> {
    return apiClient.post('/reports', auditRunId ? { audit_run_id: auditRunId } : {}).then((r) => r.data);
  },

  find(id: number): Promise<{ success: boolean; data: StoreReport }> {
    return apiClient.get(`/reports/${id}`).then((r) => r.data);
  },

  destroy(id: number): Promise<void> {
    return apiClient.delete(`/reports/${id}`).then(() => undefined);
  },
};
